// The wording of the "sign in" nudge after a win. A running streak is the most
// convincing thing to offer to save (this is how Supercell and Subway Surfers
// frame it), so it leads when there is one.

export interface SavePromptCopy {
  title: string
  body: string
}

/** A streak of 2+ days is worth naming; before that, offer to keep progress in general. */
export const MIN_STREAK_TO_MENTION = 2

export const savePromptCopy = (currentStreak: number): SavePromptCopy =>
  currentStreak >= MIN_STREAK_TO_MENTION
    ? {
        title: `Save your ${currentStreak}-day streak`,
        body: 'Sign in so your streak and stats come with you if you switch devices. No password needed.',
      }
    : {
        title: 'Keep your progress safe',
        body: 'Sign in to save your name and stats, and get them back on a new device. No password needed.',
      }
